import { faGift } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useIntl } from "react-intl";
import { displayPopin } from "../../Hook/popins";
import { useResolvedMode } from "../../Hook/theme";
import { AdsBannerProps } from "../AdsBanners/config";
import AdTile from "../AdsBanners/AdTile";
import "./dailyspinbanner.css";

/**
 * Family A, daily spin (2d): the gradient drops its orange stop and stays
 * magenta-violet, so the reward never reads as the tokens top-up (which keeps
 * the warm end alone) and never shares a stop with the subscription tile.
 * Sparkles and the bouncing gift survive; the dismissal is the shared 24h one.
 */
const MODES = {
  dark: "bg-gradient-to-r from-[#d946ef] to-[#a855f7] shadow-[0_18px_40px_rgba(168,85,247,0.35)] border border-white/30",
  light: "bg-gradient-to-r from-[#c026d3] to-[#9333ea] shadow-[0_18px_40px_rgba(147,51,234,0.28)] border border-white/30",
};

function DailySpinBanner({ onDismiss }: AdsBannerProps) {
  const intl = useIntl();
  const display = displayPopin();
  const mode = useResolvedMode();

  return (
    <AdTile
      testId="ad-dailyspin"
      onOpen={() => display("dailyspin")}
      onDismiss={onDismiss}
      className={MODES[mode]}
    >
      {/* Decorative sparkles ride above the gradient, below the copy. */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="dailyspin-banner-sparkle absolute top-2 left-[10%] w-2 h-2 bg-white rounded-full opacity-60" />
        <div className="dailyspin-banner-sparkle absolute top-6 left-[30%] w-1.5 h-1.5 bg-yellow-200 rounded-full opacity-50 [animation-delay:0.4s]" />
        <div className="dailyspin-banner-sparkle absolute bottom-4 left-[60%] w-2 h-2 bg-white rounded-full opacity-40 [animation-delay:0.8s]" />
        <div className="dailyspin-banner-sparkle absolute top-3 right-[20%] w-1 h-1 bg-yellow-100 rounded-full opacity-70 [animation-delay:1.2s]" />
      </div>

      <div className="dailyspin-banner-icon flex-none w-11 h-11 sm:w-12 sm:h-12 rounded-full bg-white/20 border-2 border-white/40 flex items-center justify-center">
        <FontAwesomeIcon icon={faGift} className="text-white text-xl" />
      </div>
      <div className="flex-1 min-w-0">
        <p className="text-sm sm:text-base font-bold text-white truncate">
          {intl.formatMessage({ id: "dailyspin_banner__title" })}
        </p>
        <p className="text-xs text-white/80 truncate">
          {intl.formatMessage({ id: "dailyspin_banner__description" })}
        </p>
      </div>
      <div className="flex-none inline-flex items-center rounded-full bg-white px-4 py-2 text-xs sm:text-sm font-bold text-[#a855f7] shadow-sm whitespace-nowrap">
        {intl.formatMessage({ id: "dailyspin_banner__button" })}
      </div>
    </AdTile>
  );
}

export default DailySpinBanner;
